<template>
  <v-card v-if="localOpen && state.progress===0" width="300">
    <v-toolbar elevation="0" color="transparent" dense>
      <v-toolbar-title>Быстрый вход</v-toolbar-title>
    </v-toolbar>
    <v-sheet>
      <v-card-text>
        <div class="text-body-2 mb-4">Укажите свой номер телефона</div>
        <v-text-field v-model="phone" label="Телефон" outlined dense hide-details="auto" v-mask="'+7 (###) ###-##-##'"/>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="localOpen=false">Отмена</v-btn>
        <v-spacer/>
        <v-btn @click="signInFast()" text color="primary" :loading="state.loading" :disabled="!$tools.isFullPhone(phone)">Далее</v-btn>
      </v-card-actions>
    </v-sheet>
  </v-card>
  <v-card v-else-if="localOpen && state.progress===1" width="400">
    <v-toolbar elevation="0" color="transparent" dense>
      <v-toolbar-title>Быстрый вход</v-toolbar-title>
    </v-toolbar>
    <div class="px-4">
      <div v-if="timerStart>=0">
        <div class="text-body-2 text-center">Ожидаем звонка с {{phone}} на</div>
        <div class="title mb-2 text-center">{{$tools.phoneFormat($tools.phoneFormat(state.data.requestPhone, true, true))}}</div>

        <div class="text-body-2 mb-2 text-center">Наведите камеру телефона что бы позвонить</div>
        <v-sheet width="100"  class="mx-auto d-block mb-2">
          <qrcode-vue :value="$tools.phoneFormat(state.data.requestPhone, true)" :size="100" level="H"/>
        </v-sheet>

        <v-btn
          @click.stop="
            $tools.copyToClipboard($tools.phoneFormat(state.data.requestPhone, true));
            $store.commit('alertSuccess', 'Скопировано: '+$tools.phoneFormat(state.data.requestPhone, true));
          "
          class="mb-2" small block depressed
        >
          Скопировать номер<v-icon small class="ml-2" color="grey">mdi-content-copy</v-icon>
        </v-btn>

        <div class="text-body-2 mb-2">Повторный запрос возможен через {{timerStart}} сек.</div>
      </div>
      <div v-else class="mb-2 text-center">
        <v-btn depressed color="primary" @click="signInFast()" :loading="state.isLoading">Повторить запрос</v-btn>
      </div>
      <div class="text-body-2 mb-2">
        Звонок будет автоматически сброшен, а система определит ваш номер телефона и выполнит вход
      </div>
      <div class="text-body-2 mb-2">
        Вам ничего говорить не нужно — достаточно одного звонка
      </div>
    </div>
    <v-card-actions>
      <v-btn text @click="localOpen=false" :loading="state.isLoading">Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Api from "@/Api";
import axios from "axios";
import Stater from "@/plugins/stater";
import QrcodeVue from 'qrcode.vue'

export default {
  components: {QrcodeVue},
  props:['open'],
  data: () => ({
    localOpen:false,
    phone:null,
    state: new Stater(),
    timer:null,
    timerStart:null,
    timerRequest:null,
  }),
  mounted() {
    this.localOpen = this.open
    if(this.localOpen) this.state.progress = 0;
  },
  watch: {
    open() {
      this.localOpen = this.open
      if(this.localOpen) this.state.progress = 0;
    },
    localOpen() {
      this.$emit('update:open', this.localOpen)
      if(this.localOpen) this.state.progress = 0;
    }
  },
  destroyed() {
    if(this.timer!==null)
      clearInterval(this.timer);
    if(this.timerRequest!==null)
      clearInterval(this.timerRequest);
  },
  methods: {
    signInFast(){
      this.state.stateLoading()
      axios.post(Api.host+'/signIn/fast/request/', {
        phone:this.phone
      })
          .then(r=>{
            this.state.data = r.data
            this.state.progress = 1
            this.state.stateSuccess()

            this.timerStart = r.data.timeoutSec*60;
            if(this.timer!==null) clearInterval(this.timer);
            this.timer = setInterval(()=>{
              this.timerStart-=1;
              if(this.timerStart<0){
                clearInterval(this.timer);
                clearInterval(this.timerRequest);
              }
            }, 1000);

            if(this.timerRequest!==null) clearInterval(this.timerRequest);
            this.timerRequest = setInterval(()=>{
              axios.post(Api.host+'/signIn/fast/check/', {
                token:this.state.data.token
              },{ skipGlobalError: true })
                  .then(r=>{
                    this.$store.state.user = r.data;
                  });
            }, 5000);
          })
          .catch(() =>{
            this.state.stateError()
          });
    }
  }
}
</script>